<main class="products-page container">
  <h1 class="products-page__header">
    {{ 'routes.products' | translate }}
  </h1>

  <div class="products-page__content">
  @if (filtersSheetOpen() || sortsSheetOpen()) {
    <button
      type="button"
      class="products-page__backdrop"
      (click)="closeFiltersSheet(); closeSortsSheet()"
      [attr.aria-label]="'global.close' | translate"></button>
  }

  <!-- filters -->
  <aside
    class="products-page__filters"
    [class.products-page__filters--sheet]="filtersSheetOpen()">
    <div class="products-page__sheet-head">
      <h2 class="products-page__sheet-title">
        {{ 'solutions.filters.toggle' | translate }}
      </h2>
      <button
        type="button"
        class="products-page__sheet-close"
        (click)="closeFiltersSheet()"
        [attr.aria-label]="'global.close' | translate">
        <i class="iconsax" icon-name="x"></i>
      </button>
    </div>
    <div class="products-page__sheet-body">
      <pwj-filters-panel titleKey="solutions.filters.toggle" icon="filter-search">
        <pwj-products-filters></pwj-products-filters>
      </pwj-filters-panel>
    </div>
  </aside>

  <pwj-mobile-sorts-sheet
    [sorts]="sortItems"
    translateKey="sorting."
    sortParamKey="sort"
    [isOpen]="sortsSheetOpen()"
    (closed)="closeSortsSheet()" />

  <!-- products -->
  <pwj-cards-list
    class="products-page__products"
    [showFiltersTriggerOnSortBar]="showFiltersTriggerOnSortBar()"
    (filtersFromSortBar)="onFiltersFromSortBar()"></pwj-cards-list>
  </div>
</main>
